import { useTranslation } from 'react-i18next';

const Option = (props) => {
  if (props.selected === props.value) {
    return <option value={props.value} selected="selected">{props.name}</option>
  }
  return <option value={props.value}>{props.name}</option>
}
export const SexDropdown = (props) => {
  const { t } = useTranslation();
  // Without this, an animal whose sex is genuinely unset has nothing in the
  // list matching props.selected ("" matches neither "m" nor "f"), so an
  // uncontrolled native <select> silently falls back to showing whichever
  // option is listed first ("Male") — actively misleading, since it looks
  // like a real value was already chosen. Only relevant for the per-row
  // editable dropdown; the filter dropdown's blank option is showAll's
  // "All Sexes", which already covers this case for it.
  const needsPlaceholder = !props.showAll && props.selected !== 'm' && props.selected !== 'f';
  return (
    <select name="sex" onChange={props.onChange} style={props.style}>
      {props.showAll &&
       <option value="">{t("all_sexes")}</option>
      }
      {needsPlaceholder &&
       <option value="" disabled selected="selected">{t("sex_not_set")}</option>
      }
      <Option value="m" name={t("male")}   selected={props.selected}/>
      <Option value="f" name={t("female")} selected={props.selected}/>
      {props.showUnset &&
       <Option value="unset" name={t("sex_not_set")} selected={props.selected}/>
      }
    </select>
  );
}
export default SexDropdown;
